import { Component, Input } from '@angular/core';

export interface SplitButtonOption {
  label: string;
  value: any;
  onClick: () => void;
}

@Component({
  selector: 'app-dc-split-button',
  templateUrl: './dc-split-button.component.html',
  styleUrls: ['./dc-split-button.component.scss'],
})
export class DcSplitButtonComponent {
  @Input() items: SplitButtonOption[];

  ngOnInit(): void {
    // Sort the items by label
    this.items = this.items.sort((a, b) => a.label.localeCompare(b.label));
  }
}
